import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalPersonalizationComponent } from './modal-personalization.component';
import { SvgModule } from '../../svg/svg.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ModalPersonalizationComponent],
  imports: [CommonModule, SvgModule, MatDialogModule],
  entryComponents: [ModalPersonalizationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ModalPersonalizationModule {}
